import { isAllowed } from '../cmp/utils';
const MILLISECONDS_PER_DAY = 86400000;
const COOKIE_DEFAULT_PATH = '/';
const MAX_EXPIRATION_DATE_IN_DAYS = 13 * 30; // Thirteen months according to GDPR regulation

class CookieHelper {
  constructor(name, value = '', daysToExpire, domain = null) {
    this.name = name;
    this.value = value;
    this.path = COOKIE_DEFAULT_PATH;
    this.expiration = daysToExpire;
    this.domain = domain;
  }
  get expiration() {
    return this._expiration;
  }
  set expiration(daysToExpire) {
    if (daysToExpire === 'Session') {
      this._expiration = null;
    } else {
      daysToExpire =
        Number.isInteger(daysToExpire) &&
        daysToExpire <= MAX_EXPIRATION_DATE_IN_DAYS
          ? daysToExpire
          : MAX_EXPIRATION_DATE_IN_DAYS;
      const expirationDate = new Date();
      const expirationTime =
        expirationDate.getTime() + daysToExpire * MILLISECONDS_PER_DAY;
      expirationDate.setTime(expirationTime);
      this._expiration = expirationDate.toUTCString();
    }
  }
  toString() {
    const props = [this.name, 'expires', 'path', 'domain'];
    const values = [this.value, this.expiration, this.path, this.domain];
    return props
      .reduce((cookieChunks, prop, i) => {
        const value = values[i];
        if (value !== null) {
          cookieChunks.push(`${prop}=${value}`);
        }
        return cookieChunks;
      }, [])
      .join('; ');
  }
  static fromDocumentCookieString(name, documentCookieString = '') {
    const browserCookies = documentCookieString.split(';');
    const nameEQ = `${name}=`;
    const matchingNameCookie = browserCookies.find(
      cookie => cookie.indexOf(nameEQ) !== -1
    );
    const value = matchingNameCookie
      ? matchingNameCookie.substring(
          matchingNameCookie.indexOf(nameEQ) + nameEQ.length
        )
      : null;
    return new CookieHelper(name, value);
  }
}

export const createCookieRepository = () => ({
  get: key => {
    let cookieValue;

    if (isAllowed('cookies', key)) {
      // eslint-disable-next-line no-restricted-properties
      cookieValue = CookieHelper.fromDocumentCookieString(key, document.cookie)
        .value;
    }
    return cookieValue || null;
  },
  set: (name, value, days, domain) => {
    const cookie = new CookieHelper(name, value, days, domain);
    if (isAllowed('cookies', name)) {
      document.cookie = cookie.toString(); // eslint-disable-line no-restricted-properties
    }
  },
  delete: key => {
    const cookie = new CookieHelper(key, '', -1);
    document.cookie = cookie.toString(); // eslint-disable-line no-restricted-properties
  },
});
